import { BRAND } from "../lib/brand";

/**
 * Renders either the product image or a branded "Image Coming Soon" placeholder
 * when no src is provided. The caller supplies the wrapper className to control
 * dimensions and rounding.
 */
const ProductImage = ({ src, alt, className = "", size = "lg" }) => {
  if (src) {
    return <img src={src} alt={alt} loading="lazy" className={className} />;
  }

  const logoSize = {
    sm: "w-6 h-6",
    md: "w-10 h-10",
    lg: "w-20 h-20",
  }[size];
  const textSize = {
    sm: "text-[7px] tracking-[0.15em]",
    md: "text-[8px] tracking-[0.18em]",
    lg: "text-[10px] tracking-[0.22em]",
  }[size];
  const gap = size === "sm" ? "gap-1" : "gap-2";

  return (
    <div
      data-testid="product-image-placeholder"
      className={`${className} flex flex-col items-center justify-center ${gap} bg-gradient-to-br from-[#0a0a12] via-[#0e0e1c] to-[#050508] border border-white/5`}
    >
      <img
        src={BRAND.logo}
        alt={`${BRAND.name} logo`}
        className={`${logoSize} rounded-full object-cover shadow-[0_0_12px_rgba(255,26,140,0.35)]`}
      />
      {size !== "sm" && (
        <span className={`${textSize} uppercase text-gray-400 text-center px-1 leading-tight`}>
          Photo coming soon
        </span>
      )}
    </div>
  );
};

export default ProductImage;
